module.exports = __webpack_public_path__ + "img/particle_motion_00109.1a4fceb6.png";